export class Popup {
	test() {
		console.log("popup us working");
	}

	show() {
		$("body, header, main, footer").addClass("blured");
		$(".popup-back").addClass("show");
	}

	close() {
		$("body, header, main, footer").removeClass("blured");
		$(".popup-back").removeClass("show");
		this.clear();
	}

	update(el) {
		$(".popup-cont").append(el);
	}

	clear(el) {
		$(".popups.element-hide").append($(".popup-cont").contents());
	}

	popup(el) {
		this.update($(el));
		this.show();
	}

	constructor() {
		let _p = this;
		$(document).ready(function() {
			$("body").on("click", "a.popup-link, button.popup-link", function() {
				let el = $(this).attr("href");

				if ($(this).attr('data-youtube'))
				{
					$(el).find('iframe').attr('src', 'https://www.youtube.com/embed/' + $(this).attr('data-youtube'));
				}

				_p.popup(el);
				return false;
			});

			$("body").on("click", ".popup-close", function() {
				_p.close();
				return false;
			});
		});
	}
}
